<template>
    <div class="land-nav" v-if="salesCardPage != null && salesCard != null" id="landNav">
        <div class="container">
            <ul>
                <li v-if="salesCard.project_land_site.about_init == 'true'"><a :href="salesCardPage.land_site_nav[0].link" 
                    v-scroll-to="{
                        el: salesCardPage.land_site_nav[0].link,
                        offset: -100
                    }">{{salesCardPage.land_site_nav[0].name}}</a></li>
                <li v-if="salesCard.project_land_site.location_init == 'true'"><a :href="salesCardPage.land_site_nav[1].link"
                    v-scroll-to="{
                        el: salesCardPage.land_site_nav[1].link,
                        offset: -100
                    }">{{salesCardPage.land_site_nav[1].name}}</a></li>
                <li v-if="salesCard.project_land_site.prems_init == 'true'"><a :href="salesCardPage.land_site_nav[2].link"
                    v-scroll-to="{
                        el: salesCardPage.land_site_nav[2].link,
                        offset: -100
                    }">{{salesCardPage.land_site_nav[2].name}}</a></li>
                <li v-if="salesCard.project_land_site.flats_init == 'true'"><a :href="salesCardPage.land_site_nav[3].link"
                    v-scroll-to="{
                        el: salesCardPage.land_site_nav[3].link,
                        offset: -100
                    }">{{salesCardPage.land_site_nav[3].name}}</a></li>
                <li v-if="salesCard.project_land_site.gallery_init == 'true'"><a :href="salesCardPage.land_site_nav[4].link"
                    v-scroll-to="{
                        el: salesCardPage.land_site_nav[4].link,
                        offset: -100
                    }">{{salesCardPage.land_site_nav[4].name}}</a></li>
                <li v-if="salesCard.project_land_site.news_init == 'true'"><a :href="salesCardPage.land_site_nav[5].link"
                    v-scroll-to="{
                        el: salesCardPage.land_site_nav[5].link,
                        offset: -100
                    }">{{salesCardPage.land_site_nav[5].name}}</a></li>
                <li v-if="salesCard.project_land_site.contacts_init == 'true'"><a :href="salesCardPage.land_site_nav[6].link"
                    v-scroll-to="{
                        el: salesCardPage.land_site_nav[6].link,
                        offset: -100
                    }">{{salesCardPage.land_site_nav[6].name}}</a></li>
            </ul>
            <!-- v-scroll-to="{
                                    el: '#section-contacts-sales-promo',
                                    offset: -50
                                }"> -->
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    // import PROMOpage from '@/components/sales/sales-promo-page.vue'
    export default {
        name: 'sale-land-nav',
        components: {
        },
        data () {
            return {
                routerName: this.$router.history.current.name,
                cardID: this.$route.params.id,
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-nav.scss';
     @import '@/styles/respond/sales/sales-land-partials/land-nav-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>